export const FEATURE_LANGUAGE_OVER_TIME = 'insight-language-over-time';
export const FEATURE_ASSIGNMENT_LIBRARY = 'insight-assignment-library';
